import React from 'react';

const SendIcon = ({ size = 24, color = "#222", ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill={color}
        {...props}
    >
        <path d="M22.5 12L1.50977 21L1.5 14L16.5 12L1.5 10L1.50977 3L22.5 12ZM3.5 15.75V17.9697L11.0098 14.75L3.5 15.75ZM3.5 8.25L11.0195 9.25L3.50977 6.03027L3.5 8.25Z" fill="black" />
    </svg>
);

export default SendIcon;